// R3 PR QA T2-2: project tab parsing, shared by ProjectPage (?tab=) and the
// deep-link redirects in App.js. The canonical URL is /project/:id?tab=<tab>,
// and the dashboard tab has no ?tab=.

export const DEFAULT_TAB = "dashboard";

export const VALID_TABS = new Set([
  "dashboard", "rooms", "timeline", "financial", "documents",
  "todos", "contacts", "calendar", "daily-logs", "selections",
  "change-orders", "reports",
]);

/** The tab for a ?tab= value: itself when valid, otherwise "dashboard". */
export function tabFromParam(value) {
  return typeof value === "string" && VALID_TABS.has(value) ? value : DEFAULT_TAB;
}

/** Canonical project URL for *tab* (bare URL for dashboard or an invalid tab). */
export function projectTabPath(projectId, tab) {
  const base = `/project/${encodeURIComponent(projectId)}`;
  const t = tabFromParam(tab);
  return t === DEFAULT_TAB ? base : `${base}?tab=${t}`;
}
